<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2>User Administration</h2>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-12">
        <card>
          <div slot="header"><h4 class="card-title">Administrative Users</h4></div>
          <div class="row">
            <div class="col-sm-12">
              <el-table :data="users"
                :default-sort="{ prop: 'username', order: 'ascending' }"
                >
                <el-table-column min-width="200" prop="username" label="Username" sortable></el-table-column>
                <el-table-column min-width="200" prop="email" label="Email" sortable></el-table-column>
                <el-table-column min-width="100" label="Email Confirmed">
                  <template scope="scope">
                    {{ !!scope.row.emailConfirmed ? 'Yes' : 'No' }}
                  </template>
                </el-table-column>
                <el-table-column min-width="200" prop="roleNames" label="Roles" sortable>
                  <template scope="scope">
                    {{ scope.row.roleNames.join(', ') }}
                  </template>
                </el-table-column>
                <el-table-column mind-width="200" align="right" label="Actions">
                  <template scope="scope">
                    <base-button class="btn-link" type="secondary" size="sm" icon>
                      <span class="sr-only">Edit User</span>
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                    <base-button v-if="!scope.row.roleNames.includes('administrator')" @click="onDelete(scope.row)" class="btn-link" type="danger" size="sm" icon>
                      <span class="sr-only">Delete User</span>
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from 'element-ui';
import { getAdminUsers, deleteAdminUser } from 'src/modules/adminActions';
import BaseButton from 'src/components/BaseButton.vue';
import swal from 'sweetalert2';
import { isNullOrEmpty } from '../../modules/utils';

export default {
  components: {
    BaseButton,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      users: []
    }
  },
  methods: {
    sortUsers() {
      this.users.sort((a, b) => a.username.toLowerCase().localeCompare(b.username.toLowerCase()));
    },
    updateUsers(data) {
      if (isNullOrEmpty(data)) {
        return;
      }

      this.users = data;
      this.users.forEach(user => {
        user.roleNames = Array.prototype.map.call(user.roles, role => role.name);
      });
    },
    deleteUserFromTable(data) {
      let retVal = { success: false, itemRemoved: null, removedIndex: -1 };
      const found = this.users.find(x => x.username === data.username);
      if (found) {
        const index = this.users.indexOf(found);
        retVal.success = true;
        retVal.removedIndex = index;
        retVal.itemRemoved = {...this.users[index]};
        this.users.splice(index, 1);
      }
      return retVal;
    },
    onDelete(row) {
      const name = row.username;
      swal.fire({
        title: 'Delete user',
        text: 'Are you sure you want to delete the user "' + name + '"?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          let payload = {
            username: name,
            refreshData: false,
          };

          deleteAdminUser(payload)
          .then(response => {
            let identityResult = response.data.result;
            let errorMessage = '';

            if(identityResult.errors && identityResult.errors.length) {
              identityResult.errors.forEach(error => {
                errorMessage += `${error.description}<br>`
              });
              swal('User Delete Error', errorMessage, 'error');
            }
            else {
              if (response.data.users) {
                this.updateUsers(response.data.users);
              }
              else {
                this.deleteUserFromTable(row);
              }
              swal('User "' + name + '" deleted', '', 'success');
            }
          });
        }
      })
    },
  },
  created() {
    getAdminUsers()
      .then((response) => {
        this.updateUsers(response.data);
      });
  }
};
</script>
